import { NestedKeyOf } from 'libs/form/types';
import { Stack } from 'libs/ui';
import { styled } from 'libs/ui/styled';
import {
  Field,
  NotificationsFormType,
} from 'modules/settings/notifications/forms/notificationsForm';

const ContentStyled = styled(Stack)({
  flex: 1,
  alignItems: 'center',
  justifyContent: 'center',
  width: 44,
});
export const renderCheckbox = (
  name: NestedKeyOf<Required<NotificationsFormType>>
) => (
  <ContentStyled>
    <Field.Checkbox name={name} size="small" />
  </ContentStyled>
);
